import template from './select.html'
/**
 * 示例
 * <e-tax-select
 *  value="item.taxRateObj"
 *  options="item.taxRateArr"
 *  disabled="notEdit"
 *  on-change="taxRateChange($index)"
 *  id="e-tax-cloud-select{{$index}}"
 *  key="taxRate"
 *  name="taxText"
 * >
 * </e-tax-select>
 */
export default function selectDirective() {
    return {
        restrict: 'E',
        scope: {
            value: '=', // 选中项，类型是对象Object
            options: '=', // 所有列表项，类型是数组Array
            disabled: '=', // 列表禁用，不能点击展开列表项，类型是布尔值
            change: '&onChange', // 选中项改变之后的回调函数，类型是函数
            id: '@', // 下拉框的唯一id，类型是字符串
            key: '@', // 匹配选项时候唯一的键值，类型是字符串
            name: '@', // 匹配选项时候显示文本字段的键值，类型是字符串
            bordered: '=', // 下拉框是否显示边框，列表选项一直显示，类型是布尔值
        },
        template,
        replace: true,
        link($scope) {
            const id = Math.floor(Math.random() * 1000000)
            $scope.id = $scope.id || `e-tax-cloud-select${id}`
            $scope.value = $scope.value || {}
            $scope.options = $scope.options || []
            $scope.key = $scope.key || 'key'
            $scope.name = $scope.name || 'name'
            $scope.isShow = false
            $scope.toggle = () => {
                if (!$scope.disabled && $scope.options.length > 0) {
                    $scope.isShow = !$scope.isShow
                }
            }
            $scope.choose = (item) => {
                if ($scope.value !== item) {
                    $scope.value = item
                    if (typeof $scope.change === 'function') {
                        $scope.change()
                    }
                }
                $scope.toggle()
            }
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/select/selectDirective.js